import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LoginFooter } from '../../components/common/CommonViews';
import { history } from '../../history';
import axios from 'axios';
import { AuthAction } from '../../actions';
import { ROUTES } from '../../config/routes';
import { resolveMailLinkTarget } from '../../lib/ticketRoute';
import { resolvePostLoginPath } from '../../lib/loginLanding';
import { safeGetItem, safeRemoveItem } from '../../lib/safeStorage';

// BUG-482: 이 화면은 로그인 폼이 아니라 "동의 전용" 화면이다. 세션은 직전 화면(LoginPage)에서
// 이미 유지된 채 넘어온다 — 여기서 다시 login() 을 호출하거나 ID/PW 를 받지 않는다.
// 전송은 오직 사용자가 체크박스 동의 후 버튼을 눌렀을 때만 발생한다(마운트 자동 전송 금지).
const IubendaLogin = ({ user, UpdateUser, logout, isUpdateRes, loggingIn, location }) => {
	const [isChecked, setIsChecked] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	// 로그인 상태가 아니면 이 화면에 머무르지 않는다.
	useEffect(() => {
		if (!loggingIn) {
			history.push(ROUTES.LOGIN);
		}
	}, [loggingIn]);

	// UpdateUser 저장 성공(isUpdateRes) 시에만 이동한다. mailLink 도 resolvePostLoginPath 를
	// 통과시켜 open-redirect 방어를 받는다(LoginPage.js 와 동일 패턴 — BUG-101).
	useEffect(() => {
		if (isUpdateRes) {
			const mailLink = safeGetItem('mailLink');
			if (mailLink) {
				safeRemoveItem('mailLink');
				// IMP-448: LoginPage.js 와 동일하게 티켓 딥링크는 권한에 맞는 목적지로 먼저 확정한다.
				window.location.assign(resolvePostLoginPath(user, resolveMailLinkTarget(user, mailLink)));
			} else {
				const from = location?.state?.from;
				const fromPath = from ? `${from.pathname || ''}${from.search || ''}` : undefined;
				window.location.assign(resolvePostLoginPath(user, fromPath));
			}
		}
	}, [isUpdateRes]); // eslint-disable-line react-hooks/exhaustive-deps

	function handleChangeData(e) {
		const { checked } = e.target;
		setIsChecked(checked);
	}

	// F-004: 동의 화면의 유일한 탈출구. iubenda 전송이 실패해 이 화면에 갇히더라도
	// 반드시 눌러 로그아웃할 수 있어야 한다 — submitting(전송 진행 중) 동안만 막는다.
	function handleLogout() {
		if (submitting) {
			return;
		}
		logout();
	}

	async function handleConsent(e) {
		e.preventDefault();
		if (!isChecked || submitting) {
			return;
		}

		setSubmitting(true);
		setErrorMessage('');

		const datas = {
			subject: {
				email: user?.email,
				first_name: user?.firstName,
				last_name: user?.lastName,
				verified: true
			},
			preferences: { "privacy_policy": true },
			legal_notices: [
				{ "identifier": "privacy_policy" },
				{ "identifier": "cookie_policy" },
				{ "identifire": "terms", "version": "v1" }
			],
			proofs: [{ "content": "proof_content", "form": "proof_form" }]
		};

		try {
			const response = await axios.post('https://consent.iubenda.com/consent/', datas, {
				headers: {
					'Content-Type': 'application/json',
					'ApiKey': 'ztt0UUW2CTUlnc5OdhdQzynyNfqzKNBf',
					'Accept': 'application/json',
				}
			});
			const subjectId = response?.data?.subject_id;
			UpdateUser({ isIubenda: true, isIubendaId: subjectId });
		} catch (err) {
			// CLAUDE.md 규칙 7 — silent-drop 금지. 빈 catch 로 삼키지 않는다(BUG-482 원인).
			console.warn('[IubendaLogin] iubenda consent submit failed', {
				handler: 'IubendaLogin.handleConsent',
				adminid: user?.adminid,
				reason: err?.message || 'unknown error',
			});
			setErrorMessage('Failed to save your consent. Please try again.');
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<>
			<div className="login">
				<div className="appHeader no-border transparent position-absolute">
					<div className="left"> </div>
					<div className="pageTitle"></div>
				</div>
				<div id="appCapsule" className="no-bottom">
					<div className="section mt-5 text-center">
						<h1>RAYGuard</h1>
					</div>
					<div className="section mb-5 p-2">
						<form>
							<div className="card">
								<div className="card-body pb-1">
									<div>
										<input type="checkbox"
											checked={isChecked}
											onChange={handleChangeData} />&nbsp;
										<label className="form-check-label">
											<a href="https://www.iubenda.com/privacy-policy/85310967/legal" className="iubenda-nostyle iubenda-embed" title="Privacy Policy" target='_blank' rel="noreferrer"> Privacy Policy </a><script type="text/javascript" src="https://cdn.iubenda.com/iubenda.js"></script>
											and agree to it including the transfer and use of my personal data.
										</label>
									</div>

									{errorMessage && (
										<div className="text-danger mt-2">{errorMessage}</div>
									)}

									<div className="mt-2 transparent">
										<button
											type="submit"
											className="btn btn-primary btn-block waves-effect waves-classic"
											disabled={!isChecked || submitting}
											onClick={handleConsent} >
											I Agree
										</button>
									</div>

									<div className="mt-2 transparent">
										<button
											type="button"
											className="btn btn-outline-secondary btn-block waves-effect waves-classic"
											disabled={submitting}
											onClick={handleLogout} >
											Log Out
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
					<LoginFooter />
				</div>
			</div>
		</>
	);
};

const mapState = (state) => {
	return {
		loggingIn: state.AuthReducer.loggingIn,
		user: state.AuthReducer.user,
		isUpdateRes: state.AuthReducer.isUpdateRes
	};
};

const mapDispatch = (dispatch) => ({
	UpdateUser: userInfo => dispatch(AuthAction.UpdateUser(userInfo)),
	logout: () => dispatch(AuthAction.Logout()),
});

export default connect(mapState, mapDispatch)(IubendaLogin);
